import { FormControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function validateRequired(err, field: FormlyFieldConfig) {
  return `Campo obbligatorio`;
}
export function validateMinLength(err, field: FormlyFieldConfig) {
  return `Deve avere almeno ${field.templateOptions.minLength} caratteri`;
}
export function validateMaxLength(err, field: FormlyFieldConfig) {
  return `Deve avere meno di ${field.templateOptions.maxLength} caratteri`;
}
export function validateMin(err, field: FormlyFieldConfig) {
  return 'Il valore deve essere maggiore di ' + field.templateOptions.min;
}
export function validateMax(err, field: FormlyFieldConfig) {
  return `Il valore deve essere minore di ${field.templateOptions.max}`;
}

// Custom validation
export function IpValidator(control: FormControl): ValidationErrors {
  return !control.value || /(\d{1,3}\.){3}\d{1,3}/.test(control.value) ? null : { 'ip': true };
}
export function IpValidatorMessage(err, field: FormlyFieldConfig) {
  return `"${field.formControl.value}" non è un indirizzo IP valido`;
}
